import { getMessages } from '../../../../../../store/constants';
import { GOOGLE_SPACING } from '../../../../../../const';

export const TOPBAR_FILTER_PLACEHOLDER = getMessages().getText('common.search');
export const TOPBAR_FILTER_FOCUSED_PLACEHOLDER = getMessages().getText('top_bar.filter.focused');
export const TOPBAR_FILTER_RECENT_EMPTY_PLACEHOLDER = getMessages().getText('top_bar.filter.empty');
export const TOPBAR_FILTER_HEADER = getMessages().getText('top_bar.filter.recent');
export const TOPBAR_FILTER_MOBILE = getMessages().getText('top_bar.filter.mobile');
export const TOPBAR_FILTER_TOOLTIP = getMessages().getText('top_bar.filter.tooltip');
export const TOP_BAR_FILTER_SECTIONS = [
    {field: 'text', name: 'Titles'},
    {field: 'description', name: 'Descriptions'},
    {field: 'comments', name: 'Comments'}
];

export const MEDIA_DEFAULT = 1200;
export const SEARCH_LIMIT = 5;

export const SMALL_SCREEN_SIZE = GOOGLE_SPACING * 138;
